import React from 'react';
import {
    Dialog,
    DialogActions,
    DialogContent,
    Button,
    Icon,
    Zoom,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ReactPlayer from "react-player";

const useStyles = makeStyles((theme) => ({
    dialog: {
		maxWidth: '60%'
	},
}));

const VideoDialog = (props) => {
    
	const classes = useStyles();
    
 	return (
        <Dialog 
            open={props.dialogIsOpen}  
            onClose={(event, reason) => {
                if(reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
                    props.handleDialogClose(true)
                }
            }}
            aria-labelledby="spotlight-video-dialog" 
            fullWidth 
            classes={{ paperFullWidth: classes.dialog }}
        //    maxWidth="md"
            TransitionComponent={Zoom}
        >
            <DialogContent className='p-1'>
                <ReactPlayer
                    url={props.url}
                    width="100%"
                    height="360px"
                    controls={true}
                    playIcon={<Icon>play_circle_filled</Icon>}
                />
            </DialogContent>
            <DialogActions className="dialog-footer">
                <Button onClick={props.handleDialogClose} color="primary">
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
  	)
}

export default VideoDialog;